import styled, { css } from 'styled-components';

import { FlatButton, StandardButton } from '@ui/buttons/Button.tsx';
import { Icon } from '@ui/icons/Icon.tsx';

export const guidanceButtonTypography = css`
  /* Outrank the scoped button reset. */
  && {
    font-family: ${({ theme }) => theme.fonts.family};
    ${({ theme }) => theme.fontSize('16px')};
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0;
  }
`;

export const RouteInfo = styled.h2`
  flex: 1 0 auto;
  display: flex;
  flex-direction: row;
  padding: 14px 12px 6px;
  margin: 0 0 10px;
  align-items: center;
  line-height: 24px;
  font-size: inherit;
  font-weight: inherit;

  .label {
    display: block;
    color: var(--color-secondaryText);
    ${({ theme }) => theme.fontSize('14px')};
  }

  .info {
    color: var(--color-primaryText);
    ${({ theme }) => theme.fontSize('20px')};
    font-weight: 500;
    line-height: 1.3em;
  }

  .info-secondary {
    color: var(--color-secondaryText);
    ${({ theme }) => theme.fontSize('12px')};
    padding-inline-start: 5px;

    &--accent {
      color: var(--color-primary);
      padding: 5px 0 0;
      margin-inline-start: -5px;
      font-weight: 500;
    }
  }
`;

export const ButtonsContainer = styled.div`
  /* flex: 0 0 auto; */
  flex: 1 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 15px;
  gap: 10px;

  /* Allow smart expansion when buttons wrap to multiple rows */
  ${({ $isWrapped }) =>
    $isWrapped
      ? `
        height: auto;
        max-height: none;
      `
      : `
        height: 40px;
      `}
`;

export const StyledFlatButton = styled(FlatButton)`
  display: flex;
  flex: 1 0 0;
  align-self: center;
  margin: 0 7px;
  height: 40px;
  ${({ theme }) => theme.fontSize('14px')};
  padding: 0 8px;

  &:first-child {
    margin-inline-start: 0;
  }

  &:last-child {
    margin-inline-end: 0;
  }
`;

export const EndNavigationButton = styled(StandardButton)`
  ${guidanceButtonTypography}
  flex: none;
  height: 40px;
  color: var(--color-destructiveButtonText);
  background-color: var(--color-destructiveButton);

  /* Outrank the scoped button reset. */
  && {
    margin: 4px 16px 20px;
  }

  .-desktop & {
    height: 28.77px;
  }

  &:not([disabled]):hover {
    color: var(--color-destructiveButtonText);
    background-color: var(--color-destructiveButtonHover);
  }
`;

export const StepIconWrapper = styled.div`
  width: 36px;
  margin-inline-end: 12px;
  text-align: center;

  ${Icon} {
    vertical-align: middle;
  }
`;

export const MobileStandardButton = styled(StandardButton)`
  flex: 1 1 0px;
  width: 169px;
  height: 40px;
  flex-shrink: 0;
`;

export const MobileStandardSecondaryButton = styled(MobileStandardButton)`
  background-color: var(--color-secondaryButton);
  color: var(--color-secondaryButtonText);
  flex: 1 1 0px;

  ${Icon} {
    fill: var(--color-secondaryButtonText);
  }

  &:not([disabled]):hover {
    background-color: var(--color-secondaryButton);

    .-desktop & {
      background-color: var(--color-secondaryButtonHover);
    }
  }
`;
